import { partnerHasSession } from "../Login/partnerHasSession";
import { queryString } from '../../../Utility/Session';

const partnersKey = queryString("partnersKey") ;
const superSessionToken = queryString("superSessionToken") ;

export function init() {
  partnerHasSession({partnersKey, superSessionToken});
}
